import React, { useState } from "react";
import AddUser from "./AddUser.js";
import AddProject from "./AddProject.js";
import AddDecline from "./AddDecline.js";
import Remarks from "./AddRemarks.js";
import PayType from "./AddPayType.js";
import AddCompany from "./AddCompany.js";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import {
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
  Work as WorkIcon,
  Cancel as CancelIcon,
  Payment as PaymentIcon,
  ChatBubble as ChatBubbleIcon,
  Business,
} from "@mui/icons-material";

export default function AdministratorDashboard() {
  const [selectedPage, setSelectedPage] = useState("addProject");
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: "Add User", icon: <PersonAddIcon />, value: "addUser" },
    { text: "Add Project", icon: <WorkIcon />, value: "addProject" },
    { text: "Add Decline", icon: <CancelIcon />, value: "addDecline" },
    { text: "Add Remarks", icon: <ChatBubbleIcon />, value: "addRemarks" },
    { text: "Add PayType", icon: <PaymentIcon />, value: "addPayType" },
    { text: "Add Company", icon: <Business />, value: "addCompany" },
  ];

  const renderContent = () => {
    switch (selectedPage) {
      case "addUser":
        return <AddUser />;
      case "addProject":
        return <AddProject />;
      case "addDecline":
        return <AddDecline />;
      case "addRemarks":
        return <Remarks />;
      case "addPayType":
        return <PayType />;
      case "addCompany":
        return <AddCompany />;
      default:
        return <AddUser />;
    }
  };

  // Mobile Icon Bar
  const mobileIconBar = (
    <Box
      sx={{
        width: "60px",
        height: "100%",
        bgcolor: "background.paper",
        borderRight: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 1,
      }}
    >
      {menuItems.map((item) => (
        <IconButton
          key={item.value}
          onClick={() => setSelectedPage(item.value)}
          sx={{
            mb: 2,
            bgcolor:
              selectedPage === item.value ? "action.selected" : "inherit",
            "&:hover": {
              bgcolor: "action.hover",
            },
          }}
        >
          {item.icon}
        </IconButton>
      ))}
    </Box>
  );

  // Full Drawer Content
  const drawerContent = (
    <>
      {isMobile && (
        <Box display="flex" justifyContent="flex-end" p={1}>
          <IconButton onClick={handleDrawerToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.value}
            onClick={() => {
              setSelectedPage(item.value);
              if (isMobile) handleDrawerToggle();
            }}
            sx={{
              bgcolor:
                selectedPage === item.value ? "action.selected" : "inherit",
              "&:hover": {
                bgcolor: "action.hover",
              },
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </>
  );

  return (
    <>
      <div
        className="pageContent"
        style={{
          width: "100vw",
          height: "91vh",
          display: "flex",
          position: "relative",
        }}
      >
        {/* Desktop Drawer */}
        {!isMobile && (
          <Drawer
            variant="permanent"
            sx={{
              width: 240,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: 240,
                boxSizing: "border-box",
                position: "relative",
              },
            }}
          >
            {drawerContent}
          </Drawer>
        )}

        {/* Mobile Layout */}
        {isMobile && (
          <>
            {/* Mobile Icon Bar */}
            {mobileIconBar}

            {/* Mobile Full Drawer */}
            <Drawer
              variant="temporary"
              anchor="left"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: 240,
                  boxSizing: "border-box",
                },
              }}
            >
              {drawerContent}
            </Drawer>
          </>
        )}

        {/* Main content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: "auto",
            ml: isMobile ? "60px" : 0, // Adjust margin for mobile icon bar
          }}
        >
          {renderContent()}
        </Box>
      </div>
    </>
  );
}
